import swal from "sweetalert";

var input_eye_pass=0,input_eye_pass_2=0,input_eye_pass_3=0;
$('.input_eye_pass').click(function () {
    if(input_eye_pass == 0){
        $('#pass').attr('type', 'text');
        input_eye_pass = 1;
    }else{
        $('#pass').attr('type', 'password');
        input_eye_pass = 0;
    }
});

$('.input_eye_pass_2').click(function () {
    if(input_eye_pass_2 == 0){
        $('#password').attr('type', 'text');
        input_eye_pass_2 = 1;
    }else{
        $('#password').attr('type', 'password');
        input_eye_pass_2 = 0;
    }
});

$('.input_eye_pass_3').click(function () {
    if(input_eye_pass_3 == 0){
        $('#passwordRe').attr('type', 'text');
        input_eye_pass_3 = 1;
    }else{
        $('#passwordRe').attr('type', 'password');
        input_eye_pass_3 = 0;
    }
});

$('.loginBtn').on('click',function () {
    Login();
});

$('#user').on('keypress',function(e) {
    if(e.which == 13) {
        Login();
    }
});

$('#pass').on('keypress',function(e) {
    if(e.which == 13) {
        Login();
    }
});



function Login() {
    $('#user').removeClass('error');
    $('#pass').removeClass('error');
    var contLogin = 1;
    if ($.trim($("#user").val()) == "" ) {
        contLogin = 0;
        $('#user').addClass('error');
    }

    if ($.trim($("#pass").val()) == "" ) {
        contLogin = 0;
        $('#pass').addClass('error');
    }

    if(contLogin == 0)
    {
        return false;
    }

    var user = $('#user').val();
    var password = $('#pass').val();
    $.ajax({
        type: "post",
        url: https + "Login",
        data: {
            user: user,
            pass: password
        },
        success: function (data) {
            if ($.trim(data) == "1") {
                location.reload();
            } else {
                swal({
                    text: "" + data,
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
}


$('.validarUserRecoveryPassword').on('click',function () {
    validarUserRecoveryPassword();
});

function validarUserRecoveryPassword()
{
    $('#user').removeClass('error');
    if ($.trim($("#user").val()) == "" ) {
        $('#user').addClass('error');
        return false;
    }
    var user = $('#user').val();
    $.ajax({
        type: "post",
        url: https + "validateUserRecoveryPassword",
        data: {
            user: user
        },
        success: function (data) {
            if ($.trim(data) == "1") {
                swal({
                    text: "Se te ha enviado un correo electrónico \n para recuperar tu contraseña",
                    icon: imageURL,
                    button: "OK!",
                });
            } else {
                swal({
                    text: "" + data,
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
}

$('.userUpdatePassword').on('click',function () {
    $('#formRecoveryPassword').submit();
});

$("#formRecoveryPassword").on('submit', function (e) {
    e.preventDefault();
    $('#idPassword').removeClass('error');
    $('#user').removeClass('error');
    $('#password').removeClass('error');
    $('#passwordRe').removeClass('error');

    var contLogin = 1;
    if ( $.trim($("#idPassword").val()) == "" ) {
        contLogin = 0;
        $('#idPassword').addClass('error');
    }

    if ( $.trim($("#user").val()) == "" ) {
        contLogin = 0;
        $('#user').addClass('error');
    }

    if ( $.trim($("#password").val()) == "" ) {
        contLogin = 0;
        $('#password').addClass('error');
    }

    if ( $.trim($("#passwordRe").val()) == "" ) {
        contLogin = 0;
        $('#passwordRe').addClass('error');
    }

    if(contLogin == 0)
    {
        return false;
    }

    var str = $.trim($("#password").val());
    var n = str.length;

    if(n<=5) {
        $('#password').addClass('error');
        $('#passwordRe').addClass('error');
        swal({
            text: "La contraseña debe tener minimo 6 caracteres",
            icon: imageURL,
            button: "OK!",
        });
        return false;
    }


    if($.trim($("#password").val()) != $.trim($("#passwordRe").val()) ){
        $('#password').addClass('error');
        $('#passwordRe').addClass('error');
        swal({
            text: "Las contraseñas deben coincidir",
            icon: imageURL,
            button: "OK!",
        });
        return false
    }

    var data = $(this).serialize();
    $.ajax({
        url: https + "userUpdatePassword",
        method: "POST",
        data: data,
        success: function (data) {
            if ($.trim(data) == "1") {
                swal({
                    text: "¡Contraseña Actualizada con exito!",
                    icon: "success",
                    button: "OK!",
                });
            }else {
                swal({
                    text: ""+data,
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });

});